import React from 'react'
import Skeleton from 'react-loading-skeleton'

export interface SkeletonParam {
  height?: number
  width?: number
  circle?: number
  count?: number
}

export const skeletonWhileLoading =
  (isLoading: boolean | undefined) =>
  <E extends JSX.Element>(e: E | string | number | undefined, param?: SkeletonParam): JSX.Element => {
    let skeleton: JSX.Element = <Skeleton />
    if (param && param.circle) {
      skeleton = <Skeleton circle={true} width={param.circle} height={param.circle} />
    }
    if (param && param.height) {
      skeleton = <Skeleton {...skeleton.props} height={param.height} />
    }
    if (param && param.width) {
      skeleton = <Skeleton {...skeleton.props} width={param.width} />
    }
    if (param && param.count) {
      skeleton = <Skeleton {...skeleton.props} count={param.count} />
    }

    return isLoading ? skeleton : <>{e}</>
  }
